<template>
  <!-- 人才招聘 -->
  <div>
    <pageNav :currentActiveNav="currentActiveNav" v-if="isMobile"></pageNav>
    <pageHeader></pageHeader>
    <div class="content">

      <pageNav :currentActiveNav="currentActiveNav" v-if="!isMobile"></pageNav>
      <div class="content-title">{{ config.title }}</div>
      <div class="content-desc">{{ config.desc }}</div>
      <div class="find">
        <div class="find-title">{{ config.findPeople.title }}</div>
        <div class="find-box">
          <div class="find-box-header">
            <div class="left-desc">{{ config.findPeople.desc }}</div>
            <el-image class="find-img" :src="config.findPeople.img" fit="cover"></el-image>
          </div>
          <div class="find-box-content">
            <div class="left-society" v-for="item in config.findPeoples" :key="item.title">
              <div class="left-society-title">{{ item.title }}</div>
              <div class="left-society-desc">{{ item.info }}</div>
              <el-tooltip effect="light" placement="top">
                <div class="left-society-btn eno-common-button">
                  {{ item.btn }}
                  <i class="el-icon-right"></i>
                </div>
                <template #content>
                  <img :src="item.tooltipBtnImg" style="width: 251px" alt="">
                </template>
              </el-tooltip>

            </div>
          </div>
          <!-- <div class="find-left">
              <div class="left-desc">{{ config.findPeople.desc }}</div>
              <div class="left-society">
                  <div class="left-society-title">{{ config.findPeople.society }}</div>
                  <div class="left-society-desc">{{ config.findPeople.societyDesc }}</div>
                  <div class="left-society-btn eno-common-button">
                      {{ config.findPeople.societyBtn }}
                      <i class="el-icon-right"></i>
                  </div>
              </div>
          </div>
          <div class="find-right">
              <el-image class="find-img" :src="config.findPeople.img" fit="cover"></el-image>
              <div class="left-society right-society">
                  <div class="left-society-title">{{ config.findPeople.school }}</div>
                  <div class="left-society-desc">{{ config.findPeople.schoolDesc }}</div>
                  <div class="left-society-btn eno-common-button">
                      {{ config.findPeople.schoolBtn }}
                      <i class="el-icon-right"></i>
                  </div>
              </div>
          </div> -->

        </div>
        <div class="find-desc">{{ config.findDesc }}</div>
      </div>
      <div class="welcome">
        <div class="welcome-title">{{ config.welcome.title }}</div>
        <div class="welcome-desc">
          <div>{{ config.welcome.descLeft }}</div>
          <div>{{ config.welcome.descRight }}</div>
        </div>
      </div>
      <div class="get">
        <div class="get-title">{{ config.get.title }}</div>
        <div class="get-list">
          <div class="get-list-item" v-for="(item, index) in config.get.getList" :key="index">
            <el-image class="get-img" :src="item.img"></el-image>
            <div>{{ item.title }}</div>
          </div>
        </div>
      </div>
      <div class="problem">
        <div class="problem-title">{{ config.problem.title }}</div>
        <div class="problem-desc">{{ config.problem.desc }}</div>
        <div class="problem-list" v-for="(item, index) in config.problem.list" :key="index">
          <div class="problem-item-title" @click="pageToDetail(item)">{{ item.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { config } from "./js/job";
import pageHeader from "./components/header.vue";
import pageNav from "./components/navMenu.vue";
import { docHtmlPath } from "@/utils";

export default {
  name: "",
  components: { pageHeader, pageNav },
  data() {
    return {
      config: config,
      currentActiveNav: '人才招聘'
    };
  },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    }
  },
  watch: {},
  mounted() {
  },
  methods: {
    pageToDetail(item) {
      docHtmlPath({
        title: item.title,
        fileName: item.fileName,
        source: this.currentActiveNav
      })
    }
  },
};
</script>

<style scoped lang="less">
.content {
  padding: 45px 68px 100px;

  .content-title {
    font-size: 48px;
  }

  .content-desc {
    font-size: 30px;
    margin: 40px 0px;
  }

  .find {
    .find-title {
      font-size: 48px;
      margin-bottom: 60px;
    }


    .find-box {

      .find-box-header {
        display: grid;
        grid-template-columns: 1fr 1fr;

        .left-desc {
          padding: 0px 44px;
          background: @mainBgColor;
          font-size: 20px;
          color: @mainTextColor;
          line-height: 40px;
          display: flex;
          align-items: center;
        }
      }

      .find-box-content {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
      }

      .left-society {
        padding: 62px 100px;
        background: @grayBgColor;

        .left-society-title {
          font-size: 30px;
        }

        .left-society-desc {
          font-size: 20px;
          margin: 20px 0;
          height: 90px;
        }

        .left-society-btn {
          font-size: 20px;
          font-weight: 500;

          .el-icon-right {
            margin-left: 10px;
          }
        }
      }
    }
  }

  .welcome {
    margin: 100px 0 60px;

    .welcome-title {
      font-size: 40px;
      margin-bottom: 40px;
    }

    .welcome-desc {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-column-gap: 40px;
      font-size: 20px;
      line-height: 40px;
    }
  }

  .get {
    padding: 90px 97px;
    background: @grayBgColor;

    .get-title {
      font-size: 24px;
      margin-bottom: 50px;
    }

    .get-list {
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      grid-column-gap: 90px;

      .get-list-item {
        text-align: center;

        .get-img {
          margin-bottom: 25px;
        }
      }
    }
  }

  .problem {
    padding: 100px 217px 0;

    .problem-title {
      font-size: 40px;
    }

    .problem-desc {
      font-size: 20px;
      line-height: 40px;
      margin: 20px 0 60px;
    }

    .problem-list {
      padding: 33px 44px;
      border-top: 1px solid @mainGrayColor3;

      &:last-child {
        border-bottom: 1px solid @mainGrayColor3;
      }

      .problem-item-title {
        font-size: 20px;

        &:hover {
          cursor: pointer;
          text-decoration: underline;
        }
      }
    }
  }
}

@media @mobile {
  .content {
    padding: 20px 16px 60px;

    .content-title {
      font-size: 20px;
      line-height: 1.3;
    }

    .content-desc {
      font-size: 14px;
      margin: 20px 0;
      line-height: 1.5;
    }

    .find {
      .find-title {
        font-size: 20px;
        margin-bottom: 30px;
      }

      .find-box {
        .find-box-header {
          grid-template-columns: 1fr;

          display: flex;
          flex-direction: column-reverse;

          .left-desc {
            padding: 20px 16px;
            font-size: 16px;
            line-height: 28px;
          }

          .find-img {
            width: 100%;
            height: auto;
            object-fit: cover;
          }
        }

        .find-box-content {
          grid-template-columns: 1fr;
          // grid-row-gap: 16px;
        }

        .left-society {
          padding: 30px 16px;
          border-top: 1px #D6D6D6 solid;

          .left-society-title {
            font-size: 20px;
          }

          .left-society-desc {
            font-size: 16px;
            margin: 16px 0;
            height: auto;
            line-height: 24px;
          }

          .left-society-btn {
            font-size: 16px;

            .el-icon-right {
              margin-left: 8px;
              font-size: 14px;
            }
          }
        }
      }

      .find-desc {
        font-size: 16px;
        line-height: 1.5;
        margin-top: 20px;
      }
    }

    .welcome {
      margin: 40px 0 30px;

      .welcome-title {
        font-size: 20px;
        margin-bottom: 20px;
      }

      .welcome-desc {
        grid-template-columns: 1fr;
        grid-column-gap: 0;
        grid-row-gap: 16px;
        font-size: 17px;
        line-height: 28px;
      }
    }

    .get {
      padding: 40px 16px;

      .get-title {
        font-size: 20px;
        margin-bottom: 30px;
      }

      .get-list {
        grid-template-columns: repeat(2, 1fr);
        grid-column-gap: 20px;
        grid-row-gap: 20px;

        .get-list-item {
          .get-img {
            margin-bottom: 16px;
            width: 60px;
            height: auto;
          }
        }
      }
    }

    .problem {
      padding: 40px 0 0;

      .problem-title {
        font-size: 20px;
      }

      .problem-desc {
        font-size: 14px;
        line-height: 28px;
        margin: 16px 0 30px;
      }

      .problem-list {
        padding: 20px 0;

        .problem-item-title {
          font-size: 16px;
        }
      }
    }
  }
}
</style>
